






















































































































import { Component, Watch, Vue } from "vue-property-decorator";
import LanguageManager from "./components/LanguageManager.vue";
import MenuManager from "@/components/MenuManager.vue";
import DialogManager from "@/components/DialogManager.vue";
import Footer from "@/components/stateless/Footer.vue";
import SnackBar from "@/components/SnackBar.vue";
import RouteTranslations from "@/locales/routerTranslations";
import { UtilitiesRequests } from "@/helpers";
import { UtilitiesFunctions } from "@/helpers";
import ProfileWidget from "@/components/privateAreas/ProfileWidget.vue";
import CookieLaw from "vue-cookie-law";

@Component({
  components: {
    DialogManager,
    Footer,
    LanguageManager,
    MenuManager,
    ProfileWidget,
    SnackBar,
    CookieLaw
  }
})
export default class App extends Vue {
  handleRoute = UtilitiesFunctions.handleRoute;
  translations: any = RouteTranslations;
  drawer: boolean = false;
  mobileWidth: boolean = false;
  $refs: any["$refs"] & {
    formRef: any;
  };
  mainMenuItems: Array<any> = [];
  menuItems: Array<any> = [];
  authMenuItems: Array<any> = [];
  routeNames: string[] | null = null;
  profileAreaStyle?: any = { "background-color": `` };
  loaded = false;
  bannerHidden: boolean = false;
  isHome: boolean = false;

  @Watch("$i18n.locale", { immediate: true, deep: true })
  onLangChanged(val: string) {
    this.setMenuItems();
  }

  @Watch("$store.state.session.user", { immediate: true, deep: true })
  onUserChanged(val: string) {
    this.setMenuItems();
  }

  @Watch("$route", { immediate: true, deep: true })
  onURouteChanged(to: any) {
    this.isHome = to.name == 'home';
    console.log(this.isHome);
    if (to.name === "profile") {
      this.profileAreaStyle = { "background-color": `#f2f4f6 !important` };
    } else {
      this.profileAreaStyle = { "background-color": `` };
    }
  }

  get hideAuthMenu() {
    return !!(
      this.$store.state.session.user || this.$store.state.session.cellar
    );
  }

  created() {
    this.storeTags();
  }

  bannerClicked() {
    const toRoute = UtilitiesFunctions.handleRoute("experience");
    let path = `${toRoute}/dcc88c03-5a14-41b1-a0f8-d2d4f5b5889e`;
    let routeData = this.$router.resolve({ path });
    window.open(routeData.href, "_blank");
  }

  closeBannerClicked(ev: any) {
    this.bannerHidden = !this.bannerHidden && this.isHome
    ev.preventDefault();
    ev.stopPropagation();
    console.log(ev);
  }

  mounted() {
    // if (
    //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    //     navigator.userAgent
    //   )
    // ) {
    //   // some code..
    //   console.warn(navigator.userAgent);
    // }
    this.removeSplash();
    this.setMenuItems();
    this.storeTags();
    if (window.innerWidth)
      if (window.innerWidth < 1264) this.mobileWidth = true;
  }

  storeTags() {
    UtilitiesRequests.getAllTags()
      .then((response: any) => {
        this.$store.dispatch("app/setTagsList", response);
        this.loaded = true;
      })
      .catch((error: any) => {
        this.loaded = true;
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
      });
  }

  removeSplash() {
    var element = document.getElementById("initial-splash");
    if (element && element.parentNode) element.parentNode.removeChild(element);
  }

  setMenuItems() {
    this.mainMenuItems = [
      
       {
        label: this.$t("mainMenu.experiences"),
        link: "experiences"
      },
      {
        label: this.$t("mainMenu.cellars"),
        link: "cellars"
      },
      /*{
        label: this.$t("mainMenu.about"),
        link: "about"
      },*/
      {
        label: this.$t("mainMenu.blog"),
        link: this.$t("mainMenu.linkBlog")
      },
      {
        label: this.$t("mainMenu.contacts"),
        link: "contacts"
      },
      {
        label: this.$t("mainMenu.business"),
        link: "https://business.divinea.com"
      }
    ];
    this.authMenuItems = [
      {
        label: this.$t("mainMenu.login"),
        link: "login"
      }//,
     // {
      //  label: this.$t("mainMenu.signup"),
      //  link: "signup"
      //}
    ];
    if (!this.hideAuthMenu) {
      this.authMenuItems.forEach((item: any) => {
        this.mainMenuItems.push(item);
      });
    }
    this.menuItems = this.mainMenuItems;
  }

  handleLinkTap(link: string) {
    if (link === "login") {
      this.$store
          .dispatch("app/setDialog", {
            type: "login",
            state: true
          })
          .then(() => {})
          .catch(error => {
            console.error(error);
          });
    } else if (link === "signup") {
      this.$store
          .dispatch("app/setDialog", {
            type: "signup",
            state: true
          })
          .then(() => {})
          .catch(error => {
            console.error(error);
          });
    } else if (link.includes("http")) {
      window.open(link, "_blank");
    } else if (link === "email") {
      location.href = "mailto:hello@divinea.com";
    } else {
      if (this.translations[this.$i18n.locale][link]) {
        const toRoute: string = this.translations[this.$i18n.locale][link].link;
        this.$router.push({ path: toRoute });
      }
    }
  }

  handleLogout() {
    this.$store
      .dispatch("session/logout")
      .then((): any => this.$router.replace(this.$route.path))
      .catch((error: Error) => {
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
        this.$store.commit("session/cleanCurrentUser");
      });
  }
}
